<template>
  <v-card
    :height="height"
    :width="width"
    :color="color"
    :hover="hover"
    disabled
    v-tooltip="{
      content: !isContextMenuVisible ? $t('venue.seat.context.tooltip') : null,
      placement: 'top-center',
      classes: ['org-theme'],
      targetClasses: ['it-has-a-tooltip'],
      offset:0,
      delay:{ show: 500, hide: 100 },
    }"
  >
    <v-layout row fill-height justify-center align-center wrap>
      <v-flex xs12>
        <div
          :class="[
            labelFont,
            'font-weight-bold',
            'text-xs-center',
            labelFontColor,
          ]"
        >
          {{ label }}
        </div>
      </v-flex>
    </v-layout>
  </v-card>
</template>
<script>
export default {
  name: 'SingleSeat',
  props: {
    height: {
      type: String,
      default: '50px',
    },
    width: {
      type: String,
      default: '50px',
    },
    labelFont: {
      type: String,
      default: 'body-1',
    },
    labelFontColor: {
      type: String,
      default: 'grey--text text--darken-4',
    },
    color: String,
    hover: Boolean,
    label: String,
    isContextMenuVisible:{
      type:Boolean,
      default:false
    }
  },
};
</script>
<style scoped>
.border-1px {
  border: 1px solid red;
}
</style>
